import { Outlet } from "react-router-dom"
import { LanguageProvider } from "./LanguageContext"
import { MmsServiceProvider } from "services/mms/context/MmsServiceContext"
import { MockMmsService } from "services/mms/mock/MockService"
import { AuthenticationGuardService } from "services/auth/AuthenticationGuard"
import { auth0Service } from "services/auth/auth0/service"
import { mockAuthService } from "services/auth/authmock/service"
import { AuthServiceProvider } from "services/auth/AuthContext"
import { BusinessMmsService } from "services/mms/external-api/business/business-service"
import { UserContextProvider } from "context/UserContext"

export const AppProviders = () => {
    const isMockAuth: boolean = false
    const isMockMms: boolean = false

    const mmsService = isMockMms
        ? new MockMmsService()
        : new BusinessMmsService()
    const authService = isMockAuth ? mockAuthService : auth0Service

    return (
        <AuthServiceProvider service={authService}>
            <MmsServiceProvider service={mmsService}>
                <UserContextProvider>
                    <LanguageProvider>
                        <AuthenticationGuardService component={Outlet} />
                    </LanguageProvider>
                </UserContextProvider>
            </MmsServiceProvider>
        </AuthServiceProvider>
    )
}
